import React from 'react';
import { cutText } from '../utils/TextsUtils';

interface WaitingRoomPlayerInterface {
    name: string;
    image: string;
};

function WaitingRoomPlayer({name, image}: WaitingRoomPlayerInterface) {
    const playerImage = require("../images/avatars/" + image + ".png");

    return (
        <div className="waitingRoomPlayerWrapper">
            <img className="waitingRoomPlayerImage" src={playerImage} alt="player avatar"/>
            <div className="waitingRoomPlayerName">{cutText(name, 15)}</div>
        </div>
    );
};

export default WaitingRoomPlayer;